import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import { brandsSelector } from 'containers/Portfolio/PageHeader/selectors';
import BrandPickerModal from 'components/Portfolio/BrandPickerModal';
import { BrandType, GlobalFilterKey } from 'utils/types';
import { setCurrentBrand } from 'store/global/actions';
import { updateGlobalFilterBrand, clearGlobalFilter } from 'containers/PageHeader/actions';

const ShowBrandPickerButton = () => {
  const dispatch = useDispatch();
  const brands = useSelector(brandsSelector);
  const [showModal, setShowModal] = useState(false);

  const handleBrandSelect = (client: BrandType) => {
    setShowModal(false);
    dispatch(setCurrentBrand(client.name));
    dispatch(updateGlobalFilterBrand(client.name));
    dispatch(clearGlobalFilter(GlobalFilterKey.GLOBAL));
  };

  return (
    <>
      <Button onClick={() => setShowModal(true)}>Switch Brand</Button>
      <BrandPickerModal
        brands={brands}
        show={showModal}
        onBrandSelection={handleBrandSelect}
        onClose={() => setShowModal(false)}
      />
    </>
  );
};

export default ShowBrandPickerButton;
